import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { Form, SubmitButton } from 'formik-antd';
import RegularInput from '../CustomInput/RegularInput';
import { Button } from 'antd';
import './Modals.scss';
import './RegisterPage.scss';
import { NavLink, useHistory } from 'react-router-dom';
import PageHeader from '../PageHeader/PageHeader';
import { Register } from '../../model/form/Register';
import { Context } from '../../index';
import * as Yup from 'yup';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// prettier-ignore
import {loadCaptchaEnginge,LoadCanvasTemplate,validateCaptcha} from 'react-simple-captcha';
import { observer } from 'mobx-react-lite';

const RegisterPage = (): JSX.Element => {
  const history = useHistory();
  const { store } = useContext(Context);
  if (store.isAuth) {
    history.push('/personal-area');
  }
  const captchaRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string>('');
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const formik = useFormik({
    initialValues: {
      name: '',
      secondName: '',
      lastName: '',
      email: '',
      phone: '',
      plainPassword: '',
      passwordCheck: '',
      captcha: '',
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: Yup.object({
      name: Yup.string()
        .min(2, 'Не менее 2 символов')
        .required('Укажите Ваше имя'),
      secondName: Yup.string()
        .min(2, 'Не менее 2 символов')
        .required('Укажите Ваше отчество'),
      lastName: Yup.string()
        .min(2, 'Не менее 2 символов')
        .required('Укажите Вашу фамилию'),
      email: Yup.string()
        .email('Не корректный email')
        .required('Укажите email'),
      phone: Yup.string().min(11, 'Не верно указан номер телефона'),
      plainPassword: Yup.string()
        .min(6, 'Не менее 6 символов')
        .max(12, 'Не более 12 символов')
        .required('Укажите пароль'),
      passwordCheck: Yup.string()
        .oneOf([Yup.ref('plainPassword'), null], 'Пароли не совпадают')
        .min(6, 'Не менее 6 символов')
        .max(12, 'Не более 12 символов')
        .required('Укажите пароль'),
      captcha: Yup.string()
        .min(6, 'Не менее 6 символов')
        .max(6, 'Не более 6 символов')
        .required('Введите код с картинки'),
    }),
    onSubmit: (values, actions) => {
      const register: Register = {
        email: values.email,
        firstName: values.name,
        lastName: values.lastName,
        middleName: values.secondName,
        plainPassword: values.plainPassword,
        phone: values.phone,
      };
      if (validateCaptcha(captchaRef.current?.value) === true) {
        loadCaptchaEnginge(6);
        if (captchaRef.current) {
          captchaRef.current.value = '';
        }
        store.register(register).then((resp) => {
          if ('error' in resp) {
            setShowSuccess(false);
            setError(resp.error);
            actions.setSubmitting(false);
          } else {
            actions.resetForm();
            setShowSuccess(true);
          }
        });
      } else {
        formik.errors.captcha = 'Неверно указан код';
        if (captchaRef.current) {
          captchaRef.current.value = '';
        }
      }
      actions.setSubmitting(false);
    },
  });

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  if (showSuccess && !store.isAuth) {
    return (
      <div className="userPage">
        <PageHeader title="Регистрация пользователя" />
        <div className="userPage__content">
          <div className="registrationSucsess">
            <p>
              Вы успешно зарегистрированы. На указанный при регистрации email
              отправлено письмо для подтверждения регистрации
            </p>
            <NavLink to={'/login'}>
              <button>В личный кабинет</button>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {!store.isAuth && (
        <div className="userPage">
          <PageHeader title="Регистрация пользователя" />
          <div className="userPage__content">
            <div className="registrationModal">
              <FormikProvider value={formik}>
                <Form>
                  <div className="register__container">
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder="Введите фамилию"
                        label="Фамилия"
                        required={true}
                        type="text"
                        name="lastName"
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.lastName && formik.errors.lastName ? (
                        <div className="errors">{formik.errors.lastName}</div>
                      ) : null}
                    </div>
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder="Введите имя"
                        label="Имя"
                        required={true}
                        type="text"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div className="errors">{formik.errors.name}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="register__container">
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder="Введите отчество"
                        label="Отчество"
                        required={true}
                        type="text"
                        name="secondName"
                        value={formik.values.secondName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.secondName && formik.errors.secondName ? (
                        <div className="errors">{formik.errors.secondName}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="divider" />
                  <div className="register__container">
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder="name@example.com"
                        label="Адрес электронной почты"
                        required={true}
                        type="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="errors">{formik.errors.email}</div>
                      ) : null}
                    </div>
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder=""
                        label="Номер мобильного телефона"
                        required={false}
                        name="phone"
                        mask="+7 (999) 999-99-99"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phone && formik.errors.phone ? (
                        <div className="errors">{formik.errors.phone}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="register__container">
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder="Пароль"
                        label="Придумайте пароль"
                        required={true}
                        name="plainPassword"
                        type="password"
                        value={formik.values.plainPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.plainPassword &&
                      formik.errors.plainPassword ? (
                        <div className="errors">
                          {formik.errors.plainPassword}
                        </div>
                      ) : null}
                    </div>
                    <div className="register__subContainer">
                      <RegularInput
                        width={'width-50'}
                        placeholder="Ваш пароль еще раз"
                        label="Введите пароль еще раз"
                        required={true}
                        name="passwordCheck"
                        type="password"
                        value={formik.values.passwordCheck}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.passwordCheck &&
                      formik.errors.passwordCheck ? (
                        <div className="errors">
                          {formik.errors.passwordCheck}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="captcha">
                    {formik.touched.captcha && formik.errors.captcha ? (
                      <div className="errors">{formik.errors.captcha}</div>
                    ) : null}
                    <LoadCanvasTemplate reloadText="Обновить" />
                    <input
                      className="CaptchaField"
                      placeholder="Введите код с картинки"
                      name="captcha"
                      type="text"
                      value={formik.values.captcha}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      ref={captchaRef}
                      autoComplete="off"
                    />
                  </div>
                  <div className="divider__margin" />
                  <Button.Group>
                    {error && <div className="userPage__error">{error}</div>}
                    <SubmitButton>Зарегистрироваться</SubmitButton>
                  </Button.Group>
                </Form>
              </FormikProvider>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(RegisterPage);
